// 所有异步调用接口状态

export const FETCH = "FETCH"
export const FETCH_SUCCESSED = "FETCH_SUCCESSED"
export const FETCH_FAILED = "FETCH_FAILED"

// 获取获取房间详细
export const FETCH_ENTERROOME_PARAMS = "FETCH_ENTERROOME_PARAMS"
export const FETCH_ENTERROOME_PARAMS_SUCCESSED =
  "FETCH_ENTERROOME_PARAMS_SUCCESSED"
export const FETCH_ENTERROOME_PARAMS_FAILED = "FETCH_ENTERROOME_PARAMS_FAILED"

// 更新房间线路
export const UPDATA_CLASSROOM_LINE = "UPDATA_CLASSROOM_LINE"
export const UPDATA_CLASSROOM_LINE_SUCCESSED = "UPDATA_CLASSROOM_LINE_SUCCESSED"
export const UPDATA_CLASSROOM_LINE_FAILED = "UPDATA_CLASSROOM_LINE_FAILED"

// 获取房间详细
// export const FETCH_ROOM_DETAIL = "FETCH_ROOM_DETAIL"
// export const FETCH_ROOM_DETAIL_SUCCESSED = "FETCH_ROOM_DETAIL_SUCCESSED"
// export const FETCH_ROOM_DETAIL_FAILED = "FETCH_ROOM_DETAIL_FAILED"

// 获取房间角色
export const FETCH_ROOM_ROLE = "FETCH_ROOM_ROLE"

// 获取用户信息
export const FETCH_USER_INFO = "FETCH_USER_INFO"
export const FETCH_USER_INFO_SUCCESSED = "FETCH_USER_INFO_SUCCESSED"
export const FETCH_USER_INFO_FAILED = "FETCH_USER_INFO_FAILED"

// 获取webserverdata
export const FETCH_WEBSERVER_DATA = "FETCH_WEBSERVER_DATA"
export const FETCH_WEBSERVER_DATA_SUCCESSED = "FETCH_WEBSERVER_DATA_SUCCESSED"
export const FETCH_WEBSERVER_DATA_FAILED = "FETCH_WEBSERVER_DATA_FAILED"

// 进入媒体房间
export const FETCH_MEDIA_ENTER_ROME = "FETCH_MEDIA_ENTER_ROME"
export const FETCH_MEDIA_ENTER_ROME_SUCCESSED =
  "FETCH_MEDIA_ENTER_ROME_SUCCESSED"
export const FETCH_MEDIA_ENTER_ROME_FAILED = "FETCH_MEDIA_ENTER_ROME_FAILED"

// 进入信令房间
export const FETCH_SIGNAL_ENTER_ROME = "FETCH_SIGNAL_ENTER_ROME"
export const FETCH_SIGNAL_ENTER_ROME_SUCCESSED =
  "FETCH_SIGNAL_ENTER_ROME_SUCCESSED"
export const FETCH_SIGNAL_ENTER_ROME_FAILED = "FETCH_SIGNAL_ENTER_ROME_FAILED"

// 获取设备列表
export const FETCH_DEVICE_LIST = "FETCH_DEVICE_LIST"
export const FETCH_DEVICE_LIST_SUCCESSED = "FETCH_DEVICE_LIST_SUCCESSED"
export const FETCH_DEVICE_LIST_FAILED = "FETCH_DEVICE_LIST_FAILED"
export const CHANGE_DEVICE = "CHANGE_DEVICE"
export const CHANGE_AUDIO_OUTPUT_DEVICE = "CHANGE_AUDIO_OUTPUT_DEVICE"

// 获取回放地址
export const FETCH_BACK_CLASS_URL = "FETCH_BACK_CLASS_URL"
export const FETCH_BACK_CLASS_URL_SUCCESSED = "FETCH_BACK_CLASS_URL_SUCCESSED"
export const FETCH_BACK_CLASS_URL_FAILED = "FETCH_BACK_CLASS_URL_FAILED"

// 更新房间状态
export const UPDATA_ROME_STATUS = "UPDATA_ROME_STATUS"
export const UPDATA_ROME_STATUS_SUCCESSED = "UPDATA_ROME_STATUS_SUCCESSED"
export const UPDATA_ROME_STATUS_FAILED = "UPDATA_ROME_STATUS_FAILED"

// 清空课件画布
export const CLEAR_SCREEN = "CLEAR_SCREEN"

// 获取PPT详细
export const FETCH_PPT_DETAIL = "FETCH_PPT_DETAIL"
export const FETCH_PPT_DETAIL_SUCCESSED = "FETCH_PPT_DETAIL_SUCCESSED"
export const FETCH_PPT_DETAIL_FAILED = "FETCH_PPT_DETAIL_FAILED"
export const SET_PPT_SIZE = "SET_PPT_SIZE"

// 讨论区和观众区管理
export const TOGGLE_ANNOUNCE_DIALOG = "TOGGLE_ANNOUNCE_DIALOG"
export const TOGGLE_FORBID_DIALOG = "TOGGLE_FORBID_DIALOG"
export const TOGGLE_PUSHTOP_DIALOG = "TOGGLE_PUSHTOP_DIALOG"
export const SET_ANNOUNCE_CONTENT = "SET_ANNOUNCE_CONTENT"
export const SET_PUSHTOP_CONTENT = "SET_PUSHTOP_CONTENT"
export const SET_TEMP_PUSHTOP_CONTENT = "SET_TEMP_PUSHTOP_CONTENT"
export const SET_PUSHTOP_TIP = "SET_PUSHTOP_TIP"
export const SET_FORBID_USER = "SET_FORBID_USER"
export const SET_CHATBOX_FORBID = "SET_CHATBOX_FORBID"
export const SET_USER_SILENT_LIST = "SET_USER_SILENT_LIST" // 设置用户禁言列表
export const FETCH_USER_SILENT_LIST = "FETCH_USER_SILENT_LIST"
export const SET_CURRENT_USER_NUM = "SET_CURRENT_USER_NUM"

// 切换PPT和播放器
export const TOGGLE_PLAYER_AND_PPT = "TOGGLE_PLAYER_AND_PPT"

// 进入教室后的弹窗提醒
export const UPDATA_ALERT_TIPS = "UPDATA_ALERT_TIPS"

// 设置弹窗状态
export const MEDIA_CAMERA_STATUS = "MEDIA_CAMERA_STATUS"
export const MEDIA_AUDIO_STATUS = "MEDIA_AUDIO_STATUS"

// 媒体流
export const MEDIA_LOCALSTREAM = "MEDIA_LOCALSTREAM"
export const VIDEO_LOST_RATE = "VIDEO_LOST_RATE" // 视频丢包率
export const START_GET_LOST_RATE = "START_GET_LOST_RATE"

// 是否发布媒体流
export const OPERATE_STREAM = "OPERATE_STREAM"

// 音量信息
export const MEDIA_AUDIO_LEVAL = "MEDIA_AUDIO_LEVAL"
export const MEDIA_AUDIO_VOLUME = "MEDIA_AUDIO_VOLUME"

// 混音开关状态
export const CHANGE_AUDIO_MIX_STATUS = "CHANGE_AUDIO_MIX_STATUS"

// 弹窗状态
export const ALERT_STATUS = "ALERT_STATUS"

export const COURSE_MANAGE_STATUS = "COURSE_MANAGE_STATUS"

// 更新进入房间的状态
export const UPDATA_ENTER_ROOM_STATUS = "UPDATA_ENTER_ROOM_STATUS"
// 更新是否显示蓝色模态框
export const UPDATA_ISSHOW_MODAL = "UPDATA_ISSHOW_MODAL"

// 离开媒体房间
export const EXIT_MEDIA_ROOM_SUCCESSED = "EXIT_MEDIA_ROOM_SUCCESSED"
// 离开信令房间
export const EXIT_SIGNAL_ROOM_SUCCESSED = "EXIT_SIGNAL_ROOM_SUCCESSED"

// 设置点击下课
export const AFTER_CLASS_SETTING = "AFTER_CLASS_SETTING"

// 获取视频列表
export const GET_VIDEO_LIST = "GET_VIDEO_LIST"
export const GET_VIDEO_LIST_SUCCESS = "GET_VIDEO_LIST_SUCCESS"
export const GET_VIDEO_LIST_FAILED = "GET_VIDEO_LIST_FAILED"
export const SET_VIDEO_URL = "SET_VIDEO_URL"
export const SET_VIDEO_BOX_STATUS = "SET_VIDEO_BOX_STATUS"
export const SET_VIDEO_ELEMENT = "SET_VIDEO_ELEMENT"

// 视频播放状态
export const PAUSED = "PAUSED"
export const PLAYING = "PLAYING"
export const STOPED = "STOPED"
export const SET_VIDEO_STATUS = "SET_VIDEO_STATUS"

// 屏幕共享状态
export const SCREEN_STATUS = "SCREEN_STATUS"

// 防止点击设置后重新点击视频
export const MEDIA_DISABLED = "MEDIA_DISABLED"

// 红包模态框状态
export const STUDENT_GIFT_MODEL_SHOW = "STUDENT_GIFT_MODEL_SHOW"
// 老师汇总学生数据状态
export const STUDENT_GIFT_SUCCESS = "STUDENT_GIFT_SUCCESS"

// 获取红包数据
export const FETCH_HONGBAO_DATA = "FETCH_HONGBAO_DATA"
export const FETCH_HONGBAO_DATA_SUCCESSED = "FETCH_HONGBAO_DATA_SUCCESSED"
export const FETCH_HONGBAO_DATA_FAILED = "FETCH_HONGBAO_DATA_FAILED"

// 获取领取红包的学生数据
export const FETCH_HONGBAO_STUDENT_DATA = "FETCH_HONGBAO_STUDENT_DATA"
export const FETCH_HONGBAO_STUDENT_DATA_SUCCESSED =
  "FETCH_HONGBAO_STUDENT_DATA_SUCCESSED"
export const FETCH_HONGBAO_STUDENT_DATA_FAILED =
  "FETCH_HONGBAO_STUDENT_DATA_FAILED"
// 第三方媒体类型
export const MBS_VENDOR = "mbs"
export const AGORA_VENDOR = "agora"
export const DUOBEI_VENDOR = "doubei"

export const VENDOR = {
  1: "agora",
  2: "doubei",
  3: "mbs"
}

// 神策日志打点
export const SENSORLOG = {
  sdk_version: "0.0.2",
  product: "new_openclass_live_teacher",
  course_type: "1VN",
  app_name: "new_openclass_live_teacher",
  type: {
    INIT: "init",
    SUCCESSED: "successed",
    FAILED: "failed"
  }
}
